import React from 'react';
import './CreatorContentComponent.css';
import '../../../App.css'
import {Flex, Spacer, Image, Box} from "@chakra-ui/react";
import {Animated} from "react-animated-css";
import {InnerItem} from "../../../data/InnerItem";
import {useTranslation} from "react-i18next";

interface CreatorContentComponentProps {
    itemData: InnerItem
}

const CreatorContentComponent: React.VFC<CreatorContentComponentProps> = (props) => {
    const [t, i18n] = useTranslation('common');
    return (
        <Flex alignItems="top" flexDirection="row" maxWidth="500px">
            <Animated animationIn="fadeIn"
                      animationOut="fadeOut"
                      isVisible={true}
                      animationInDuration={4000}>
                <Image
                    marginRight="20px"
                    maxWidth="54px"
                    maxHeight="54px"
                    padding="5px"
                    src={props?.itemData?.image}
                    alt={props?.itemData?.title}
                    objectFit="contain"
                />
            </Animated>
            <Spacer/>

            <Animated animationIn="fadeIn"
                      animationOut="fadeOut"
                      isVisible={true}
                      animationInDuration={4000}>
                <Flex flexDirection="column" marginRight="8" maxWidth="300px" marginTop="12px" textAlign="start">
                    <Box marginBottom="10px">
                        <span className="body-content-small">{t(props.itemData?.title)}</span>
                    </Box>
                    <span className="body-content-small-gray">{t(props.itemData?.content)}</span>
                </Flex>
            </Animated>


            <Spacer/>
        </Flex>
    )

}
export default CreatorContentComponent